import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { putNotification, removeNotification } from '../../../redux/ui/actions'
import { notification } from '../../../redux/ui/selectors'
import Snackbar from './Snackbar'

export { SnackbarType } from './Snackbar'

const selector = createStructuredSelector({
  notification,
})

const actions = {
  onClose: removeNotification,
  onCloseOneMessage: putNotification,
}

export default connect(selector, actions)(Snackbar)
